import Vue from 'vue'
import './utils/dict'
import App from './App.vue'
import router from './router'
import './permission'
import store from './store'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 
// 注册富文本编辑器
Vue.use(VueQuillEditor) 

Vue.config.productionTip = false
Vue.use(elementUI)

//EventBus事件中转
Vue.prototype.$bus = new Vue()  

//图片兜底：OSS 图片加载失败时自动回退到服务器地址
window.addEventListener('error', function (e) {
  var t = e.target
  if (t && t.tagName === 'IMG' && t.src && t.src.indexOf('ape-learn-imgs.oss-cn-hangzhou.aliyuncs.com') > -1) {
    t.src = t.src.replace('https://ape-learn-imgs.oss-cn-hangzhou.aliyuncs.com', '/api')
  }
}, true)  

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
